import { render } from "./Congratulation.vue?vue&type=template&id=086e905f&scoped=true"
import script from "./Congratulation.vue?vue&type=script&lang=js"
export * from "./Congratulation.vue?vue&type=script&lang=js"

import "./Congratulation.vue?vue&type=style&index=0&id=086e905f&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086e905f"]])

export default __exports__